import {type PayloadAction, createSlice} from '@reduxjs/toolkit';
import type {RootState} from 'store/types';
import type {HeadState} from './types';

const initialState: HeadState = {
  title: undefined,
  description: 'Bokbasen metadata',
};

const headSlice = createSlice({
  name: 'head',
  initialState,
  reducers: {
    titleUpdated(state, action: PayloadAction<string | undefined>) {
      state.title = action.payload;
    },
    descriptionUpdated(state, action: PayloadAction<string>) {
      state.description = action.payload;
    },
  },
});

export const {titleUpdated, descriptionUpdated} = headSlice.actions;
export const selectHead = (state: RootState) => state.head;

export default headSlice;
